// extracted by css-extract-rspack-plugin
export default {"aster":"aster_haRnH"};